export class ContactPreference {
    email: boolean;
    phone: boolean;
}